// client/src/components/BlockButton.js
import React, { useState, useEffect } from 'react';
import { Button, CircularProgress } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axiosInstance from '../axiosInstance';

const BlockButton = ({ targetUserId, variant = 'outlined', size = 'small', onBlockChange }) => {
  const [isBlocked, setIsBlocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    checkBlockStatus();
  }, [targetUserId]);

  const checkBlockStatus = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/blocking/is-blocked/${targetUserId}`);
      setIsBlocked(response.data.isBlocked);
    } catch (err) {
      console.error('Error checking block status:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleBlock = async () => {
    if (processing) return;

    const action = isBlocked ? 'unblock' : 'block';
    const confirmMessage = isBlocked 
      ? 'Are you sure you want to unblock this user?' 
      : 'Are you sure you want to block this user? They will not be able to message you or interact with your content.';

    if (!window.confirm(confirmMessage)) return;

    try {
      setProcessing(true);
      await axiosInstance.post(`/blocking/${action}/${targetUserId}`);
      setIsBlocked(!isBlocked);
      if (onBlockChange) onBlockChange(!isBlocked);
    } catch (err) {
      console.error(`Error ${action}ing user:`, err);
      alert(err.response?.data?.error || `Failed to ${action} user`);
    } finally {
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <Button variant={variant} size={size} disabled>
        <CircularProgress size={16} />
      </Button>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      color={isBlocked ? 'success' : 'error'}
      startIcon={processing ? <CircularProgress size={16} /> : (isBlocked ? <CheckCircleIcon /> : <BlockIcon />)}
      onClick={handleToggleBlock}
      disabled={processing}
    >
      {isBlocked ? 'Unblock' : 'Block'}
    </Button>
  );
};

export default BlockButton;
